import { render, staticRenderFns } from "./HeadlineMediaCetak.vue?vue&type=template&id=61ead362&scoped=true"
import script from "./HeadlineMediaCetak.vue?vue&type=script&lang=js"
export * from "./HeadlineMediaCetak.vue?vue&type=script&lang=js"
import style0 from "./HeadlineMediaCetak.vue?vue&type=style&index=0&id=61ead362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ead362",
  null
  
)

export default component.exports